export const GROUP_FILTER = {
  DELIVERY_SITES: 'deliverysites',
  GROUPS: 'groups',
  GROUP_EDIT: 'group-edit',
  GROUP_SEARCH: 'group-search'
}
export const WAYS_OF_ANIMATION = {
  FADE_IN: 'fadeIn',
  SLIDE_IN: 'slideIn'
}
